<div class="modal-header w-100">
    <button type="button" class="close" (click)="dismissModal()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body h-100 w-100 d-flex flex-row">
    <span class="vismaicon vismaicon-lg vismaicon-filled vismaicon-warning"></span>
    <div class="ml-2">
        <span class="mx-2 text-justify">
            {{(buttonState ? "EMPLOYEE_ROSTER_MATCHING_UPDATE_WARNING" : "EMPLOYEE_ROSTER_UPDATE_WARNING" ) | translate}}
        </span>
        <div class="d-flex flex-row justify-content-end w-100 mt-4 justify-content-around">
            <button class="btn admin-task-modal-btn btn-primary"
                    type="button"
                    translate="SAVE"
                    [disabled]="buttonState"
                    (click)="confirmModal()"
            >
            </button>
            <button class="btn admin-task-modal-btn btn-secondary"
                    type="button"
                    translate="CANCEL"
                    (click)="dismissModal()">
            </button>
        </div>
    </div>
</div>
